/**
* Created by lobin on 2020/6/17.
*/
<template>
  <div class="location">
    <a-modal
        v-model="visible"
        title="高德地图经纬度选择"
        width="600px"
        :bodyStyle="{padding:0}"
        @ok="() => visible = false"
    >
      <amap-search
          :searchCount="2"
          :autoConfirm="false"
          :useClick="true"
          :width="600"
          :height="340"
          @userInput="handleUserInput"
          @pickedLocation="handlePickedLocation">
      </amap-search>
    </a-modal>
  </div>
</template>

<script type="text/babel">
import AmapSearch from 'vue-amap-search';
import 'vue-amap-search/dist/lib/main.css';

export default {
  props: ['defaultValue'],
  components: {
    AmapSearch,
  },
  data() {
    return {
      visible: false,
      initValue: [],
    };
  },
  created() {
    this.initValue = this.defaultValue;
  },
  computed: {
  },
  methods: {
    show() {
      this.visible = true;
    },
    handleUserInput() {

    },
    handlePickedLocation(value) {
      this.$emit('change', value);
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less">

</style>
